import defaultAxios from 'axios';

import { API_URL } from '../config';

export const axios = defaultAxios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
